import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const FilledArrowHeadRight: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_arrow-head-right"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="arrow-head-right icon"
      {...restProps}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 25"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path d="M9.73966 7.70041C9.43613 7.98226 9.41856 8.45681 9.70041 8.76034L13.2265 12.5L9.70041 16.2397C9.41856 16.5432 9.43613 17.0177 9.73967 17.2996C10.0432 17.5815 10.5177 17.5639 10.7996 17.2603L14.7996 13.0103C15.0668 12.7226 15.0668 12.2774 14.7996 11.9897L10.7996 7.73966C10.5177 7.43613 10.0432 7.41856 9.73966 7.70041Z" />
      </svg>
    </span>
  );
};

export { FilledArrowHeadRight };
